/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasty_Tidy_Hamster_SmileInputs */

const fr_tasty_tidy_hamster_smile = /** @type {(inputs: Tasty_Tidy_Hamster_SmileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle catégorie`)
};

/**

* @param {Tasty_Tidy_Hamster_SmileInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tasty_tidy_hamster_smile = /** @type {((inputs?: Tasty_Tidy_Hamster_SmileInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasty_Tidy_Hamster_SmileInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tasty_tidy_hamster_smile(inputs)
});